import { useState } from 'react';
import { UserRepository, UserTokenRepository } from '../../../../MedicareProAPI';
import type { oAuthGetTokenSchema } from '../../../../MedicareProAPI/Repositories/User/UserTokenRepository';

export const CLIENT_ID = process.env.MEDICAREPRO_API_CLIENTID as string;

type LogInProperties = {
  onSuccess?: (data: oAuthGetTokenSchema) => void;
  onError?: (err: Error) => void;
};

export function useLogIn(opts: LogInProperties = {}) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const userTokenRepository = new UserTokenRepository();
  const userRepository = new UserRepository();

  async function handleSubmit({
    username: email,
    password,
  }: {
    username: string;
    password: string;
  }) {
    try {
      setSubmitting(true);
      setError(null);
      const loginResponse = await userTokenRepository.oAuthLogin({
        username: email,
        password: password,
        client_id: CLIENT_ID,
      });

      if (loginResponse.code) {
        const codeResponse = await userTokenRepository.oAuthGetToken({
          code: loginResponse.code,
          client_id: CLIENT_ID,
        });
        opts.onSuccess?.(codeResponse);
      } else {
        throw new Error('No code returned');
      }
    } catch (e: any) {
      setError(e.message ?? 'Login failed');
      opts.onError?.(e);
    } finally {
      setSubmitting(false);
    }
  }

  return { handleSubmit, submitting, error };
}
